// tslint:disable
/**
 * respondeco.org
 * API description of respondeco.org
 *
 * The version of the OpenAPI document: 1.2.5
 * Contact: klaus@respondeco.org
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

      export interface GetVideoRequest {
        videoId: string;
      }


/**
* no description
*/
export interface VideosApi {
    /**
      * Get a video
    */
    getVideo(requestParameters: GetVideoRequest): Promise<Blob>
}

  /**
  * no description
  */
  export class VideosApiImpl extends runtime.BaseAPI implements VideosApi {

    /**
      * Get a video
    */
    async getVideoRaw(requestParameters: GetVideoRequest): Promise<runtime.ApiResponse<Blob>> {
          if (requestParameters.videoId === null || requestParameters.videoId === undefined) {
          throw new runtime.RequiredError('videoId','Required parameter requestParameters.videoId was null or undefined when calling getVideo.');
          }

      const queryParameters: runtime.HTTPQuery = {};

      const headerParameters: runtime.HTTPHeaders = {};

      const response = await this.request({
      path: `/videos/{videoId}`.replace(`{${"videoId"}}`, encodeURIComponent(String(requestParameters.videoId))),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      });

          return new runtime.BlobApiResponse(response);
      }

      /**
        * Get a video
      */
      async getVideo(requestParameters: GetVideoRequest): Promise<Blob> {
        const response = await this.getVideoRaw(requestParameters);
        return await response.value();
      }

    }
